import { TranslocoService } from '@ngneat/transloco';
import { Store } from '@ngrx/store';
import {
  GenerateClauseListPayload,
  GenerateDocumentResponse,
} from 'src/app/modules/document-generation/services/document-generation-api.service';
import { DocumentsActions } from 'src/app/modules/documents/store/actions';
import { NotificationsActions } from 'src/app/modules/notifications/store/actions';
import { constants } from '../constants/constants';

export function sendDocumentGenerationSuccessNotification(
  store: Store,
  translocoService: TranslocoService,
  generateDocumentResponse: GenerateDocumentResponse,
  uniqueId: string,
) {
  const title = translocoService.translate('text.generatingDocumentSuccessTitle', {
    name: generateDocumentResponse.documentName || '',
  });

  store.dispatch(DocumentsActions.getDocuments());

  store.dispatch(
    NotificationsActions.showDocGenerationNotificationComponent({
      icon: constants.icons.greenTick,
      title,
      duration: constants.notificationGenerateDocumentHideDelay,
      docName: generateDocumentResponse.documentName || '',
      uniqueId,
    }),
  );
}

export function sendDocumentGenerationFailedNotification(
  store: Store,
  translocoService: TranslocoService,
  documentGenerationTrackingId: string,
) {
  const message = translocoService.translate('text.generatingDocumentFailText', {
    trackingId: documentGenerationTrackingId,
  });

  store.dispatch(
    NotificationsActions.showNotificationComponent({
      icon: constants.icons.redCross,
      title: translocoService.translate('text.generatingDocumentFailTitle'),
      duration: constants.notificationInfinityHideDelayKeyValue,
      message,
    }),
  );
}

export function areGenerateClausePayloadsEqual(
  first: GenerateClauseListPayload | null,
  second: GenerateClauseListPayload | null,
): boolean {
  if (!first || !second) {
    return false;
  }

  const firstParties = first.parties || [];
  const secondParties = second.parties || [];

  return (
    first.documentTypeId === second.documentTypeId &&
    first.languageId === second.languageId &&
    first.positionId === second.positionId &&
    firstParties.length === secondParties.length &&
    firstParties.every((partyId, index) => partyId === secondParties[index])
  );
}
